/**
 * Un tarif d'adhésion est-il encore achetable sur la page publique ?
 *
 * Fermé quand l'association l'a clôturé (`status: closed`) ou quand sa
 * SAISON est terminée — minuit à la fin du dernier jour, à l'heure de
 * l'association (Karim 2026-10-09 : on pouvait acheter une adhésion déjà
 * expirée). Même règle que l'API, qui refuse la commande.
 */
import { saisonAdhesionTerminee } from "@donoor/utils";
import { fuseauDe } from "~/utils/heureAssociation";

interface TarifAdhesionLike {
  status?: string | null;
  duration_type?: string | null;
  season_end_date?: string | null;
  timezone?: string | null;
}

export function saisonDuTarifTerminee(tarif: TarifAdhesionLike | null | undefined): boolean {
  if (!tarif || tarif.duration_type !== "season") return false;
  return saisonAdhesionTerminee(tarif.season_end_date, fuseauDe(tarif));
}

export function tarifAdhesionFerme(tarif: TarifAdhesionLike | null | undefined): boolean {
  return tarif?.status === "closed" || saisonDuTarifTerminee(tarif);
}

interface TarifNommeLike {
  title?: string | null;
  tarif_name?: string | null;
}

/**
 * Nom COURT d'un tarif, à afficher dans la liste des tarifs d'une adhésion.
 *
 * En multi-tarif, l'API stocke `title = "{adhésion} — {tarif}"` : afficher le
 * titre brut répétait le nom de l'adhésion devant chaque tarif (« location
 * local — Week-end »), alors que la page l'affiche déjà en grand au-dessus
 * (Karim 2026-10-19). On prend `tarif_name`, sinon la fin du titre après le
 * dernier « — », sinon le titre. Même règle que l'import d'adhérents côté API.
 */
export function nomDuTarif(tarif: TarifNommeLike | null | undefined): string {
  const nom = tarif?.tarif_name?.trim();
  if (nom) return nom;
  const titre = (tarif?.title ?? "").trim();
  const i = titre.lastIndexOf(" — ");
  return i > 0 ? titre.slice(i + 3).trim() || titre : titre;
}
